import { ArrowDownLeft, ArrowUpRight } from 'lucide-react';

import { type DocumentoDetalhe } from '@fiscoai/contracts';

import { DIRECAO, TIPO_DANFE } from './rotulos';

type Doc = Pick<DocumentoDetalhe, 'direcao' | 'tipoOperacaoEmitente'>;

/**
 * Direção da nota para a empresa ao lado do tipo impresso no DANFE (tpNF, visão de quem emitiu).
 * Quando os dois parecem opostos — fornecedor emite "1 - Saída" e para a empresa é Entrada —, uma
 * frase curta diz o porquê; quando coincidem, nada a explicar.
 */
export function DirecaoComDanfe({ doc }: { doc: Doc }) {
  const entrada = doc.direcao === 'ENTRADA';
  const Icone = entrada ? ArrowDownLeft : ArrowUpRight;
  const noDanfe = TIPO_DANFE[doc.tipoOperacaoEmitente];
  const opostos = noDanfe !== doc.direcao;
  const paraEmpresa = DIRECAO[doc.direcao];
  return (
    <span className="grid gap-1">
      <span className="inline-flex flex-wrap items-baseline gap-x-1.5">
        <span
          className={`inline-flex items-center gap-1 self-center font-medium ${entrada ? 'text-info' : 'text-texto'}`}
        >
          <Icone className="size-4" aria-hidden />
          {paraEmpresa}
        </span>
        <span className="text-sm text-texto-fraco">para a empresa</span>
      </span>
      <span className="text-sm text-texto-suave">
        No DANFE:{' '}
        <span className="tabular font-medium text-texto">
          {doc.tipoOperacaoEmitente} – {DIRECAO[noDanfe]}
        </span>{' '}
        (visão de quem emitiu)
      </span>
      {opostos && (
        <span className="text-sm text-texto-fraco">
          Quem emitiu registrou como {DIRECAO[noDanfe].toLowerCase()}; para a empresa, é{' '}
          {paraEmpresa.toLowerCase()}.
        </span>
      )}
    </span>
  );
}
